import React from 'react';
import { HealthView } from '@/components/shared/ReuseableHealth';
import { useGetMyMicrobiomeDetailV2 } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';

export const GutMicrobiomePage: React.FC = () => {
  const { data, isError, isLoading } = useGetMyMicrobiomeDetailV2('gut');

  if (isError) {
    return <ErrorLoadingPage data-testid="gutMicrobiome-error" variant="dark" />;
  }

  return (
    <HealthView
      data-testid="gutMicrobiome-page"
      profileData={data || null}
      isLoading={isLoading || !data}
      buttonText="My gut microbes"
      onClickPath="/active-microbes?type=gut"
      type="gut"
    />
  );
};
